import { FC, useState } from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { BiCheck } from "react-icons/bi";
import { Oval } from "react-loader-spinner";
import "./JobBalance.css";
import { IJob } from "../../../../Interfaces";

interface IJobBalanceProp {
  loader: boolean;
  setSelected: React.Dispatch<React.SetStateAction<IJob | null>>;
  isMobile: boolean;
  jobs: IJob[];
}

const JobBalance: FC<IJobBalanceProp> = ({
  setSelected,
  isMobile,
  jobs,
  loader,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [clickJob, setClickJob] = useState(false);
  const [jobIndex, setJobIndex] = useState(-1);
  const [jobBalance, setJobBalance] = useState("");

  const Arrow = (isActive: boolean) => {
    if (isActive) {
      return <IoIosArrowUp style={{ color: "black" }} />;
    }
    return <IoIosArrowDown style={{ color: "black" }} />;
  };

  const selectJob = (job: IJob, clickJob: boolean) => {
    
    return clickJob ? setSelected(job) : setSelected(null);
  };

  const JobBalanceView = isMobile ? (
    <div className={`dropdown-${isActive}`}>
      <div
        className={`dropdown-btn-${isActive}`}
        onClick={(e) => setIsActive(!isActive)}
        style={{
          color: jobBalance ? "#f8485e" : "",
        }}
      >
        {jobBalance ? jobBalance : "Sélectionne un métier"}
        {Arrow(isActive)}
      </div>
      {isActive && (
        <div className="dropdown-content">
          {loader ? (
            <Oval
              ariaLabel="loading-indicator"
              height={100}
              width={100}
              strokeWidth={5}
              strokeWidthSecondary={3}
              color="#3E8FC6"
              secondaryColor="#blue"
            />
          ) : (
            jobs.map((job, index) => {
              return (
                <div
                  key={index}
                  className="dropdown-item"
                  onClick={() => {
                    setJobIndex(index);
                    setSelected(job);
                    setIsActive(!isActive);
                    setJobBalance(job.jobName);
                  }}
                >
                  <p
                    className="text-item"
                    style={{ paddingLeft: jobIndex === index ? 0 : 25 }}
                  >
                    {jobIndex === index ? (
                      <BiCheck style={{ fontSize: 22 }} />
                    ) : (
                      ""
                    )}{" "}
                    {job.jobName}
                  </p>
                  <div className="dropdown-item-borderBottom"></div>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  ) : (
    <ul className="userBalanceJob">
      {loader ? (
        <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
          <Oval
            ariaLabel="loading-indicator"
            height={50}
            width={50}
            strokeWidth={5}
            strokeWidthSecondary={3}
            color="#3E8FC6"
            secondaryColor="#blue"
          />
        </div>
      ) : (
        
        jobs.map((job, index) => {
          return (
            <li
              style={{
                backgroundColor:
                  index === jobIndex && clickJob ? "#fddade" : "",
                color: index === jobIndex && clickJob ? "#f8485e" : "",
                border:
                  index === jobIndex && clickJob ? "2px solid #f8485e" : "",
                outline:
                  index === jobIndex && clickJob ?  "1px solid #f8485e" : ""
              }}
              key={index}
              onClick={() => {
                setJobIndex(index);
                setClickJob(() => {
                  const resetJobSelection = jobIndex === index ? false : true;
                  if (jobIndex === index && clickJob) {
                    
                    selectJob(job, true);
                    return true;
                  }
                  selectJob(job, resetJobSelection);
                  return resetJobSelection;
                });
              }}
            >
              {job.jobName}
            </li>
          );
        })
      )}
    </ul>
  );

  return <div>{JobBalanceView}</div>;
};

export default JobBalance;
